import React, { useRef } from 'react';
import axios from 'axios';
import { Modal, Button } from 'react-bootstrap';
import {  Input, Tooltip } from 'reactstrap';
import Select from 'react-select';
import { var_api } from "../constant";
import { useState,useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Pagination from 'react-js-pagination';
import ReactToPrint from 'react-to-print';
import Bill from '../Foods/bill';
import Swal from 'sweetalert2';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()

const Orderhistory = () => {
    const history = useHistory();
    const [selectedOrderLabel, setSelectedOrderLabel] = useState({ value: '0', label: 'All' });
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [startIndex, setStartIndex] = useState(0);
    const [ searchQuery,setSearchQuery] = useState('');
    const [isOpenBill, setIsOpenBill] = useState(false);
    const [ selectedOrderBill,setSelectedOrderBill] = useState({});
    const [ billIndex,setBillIndex] = useState(null);
    const componentRefs = useRef([]);
    const itemsPerPage = 25; 
    const [labelCodeOptions] = useState([
        { value: '0', label: 'All' },
        { value: '1', label: 'Normal Order' },
        { value: '2', label: 'Credit Order' },
        { value: '3', label: 'Group Location Order' },
        { value: '4', label: 'Normal Table Order' },
        { value: '5', label: 'Credit Table Order' },
    ]);
    const [tooltipOpen, setTooltipOpen] = useState(false);

    const toggleTooltip = () => {
      setTooltipOpen(!tooltipOpen);
    };
  

    // Function to get formatted date (dd-mm-yyyy) from a Date object
    const getFormattedDate = (date) => {
        const dd = String(date.getDate()).padStart(2, '0');
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const yyyy = date.getFullYear();
        return `${dd}-${mm}-${yyyy}`;
    };

    const [startDate, setStartDate] = useState(getFormattedDate(new Date()));
    const [endDate, setEndDate] = useState(getFormattedDate(new Date()));
    const [isOpenSelectDate, setIsOpenSelectDate] = useState(false);
    const [orderHistory, setOrderhistory] = useState({});
    const [orderSummary, setOrderSummary] = useState({});
    const [isOpenOrderSummary, setIsOpenOrderSummary] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedOrderNo, setSelectedorderNo] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [ isPayModeEdit, setIsPayModeEdit] = useState(false);
    const [ editPaymodeOrder, setEditPaymodeOrder] = useState(null);
    const [ editSelectedAmounts, setEditSelectedAmounts] = useState([]);
    const [ updateRemark, setUpdateRemark ] = useState("");
    const [ isPaymodeEditLoading, setIsPaymodeEditLoading ] = useState(false);
    const [ editModeTotal, setEditModeTotal ] = useState(null);
    const shopName = localStorage.getItem('shopName');
    const role = localStorage.getItem('e_role');
    const [puttooltipOpen, setPutToolTipOpen] = useState([]);
    const [printtooltipOpen, setPrintToolTipOpen] = useState([]);

    useEffect(() => {
        // Fetch orders history and summary when selectedOrderLabel, startDate, or endDate changes
        if (selectedOrderLabel.value !== '' && startDate !== '' && endDate !== '') {
            fetchAllOrdersHistory(selectedOrderLabel.value);
            fetchAllOrdersSummary(selectedOrderLabel.value);
        }
    }, [selectedOrderLabel, startDate, endDate, currentPage]);


  const handleOrderLabelSelectChange = (selectedOption) => {
    setSelectedOrderLabel(selectedOption);
    fetchAllOrdersHistory(selectedOption.value);
    fetchAllOrdersSummary(selectedOption.value);
  };

  const handleStartDateChange = (event) => {
    const startDate = event.target.value;
    setStartDate(formatDate(startDate));
  };

  const handleEndDateChange = (event) => {
    const endDate = event.target.value;
    setEndDate(formatDate(endDate));
  };

  const handleOpenSelectDate = () => {
    setIsOpenSelectDate(true);
  };

  const handleCloseDateConfirmation = () => {
    setIsOpenSelectDate(false);
  };

  const handleSelectDateRange = () => {
    fetchAllOrdersHistory(selectedOrderLabel.value);
    setIsOpenSelectDate(false);
    fetchAllOrdersSummary(selectedOrderLabel.value);
  };


  const togglePutTooltip = (index) => {
    const putTooltipOpen = [...puttooltipOpen];
    putTooltipOpen[index] = !putTooltipOpen[index];
    setPutToolTipOpen(putTooltipOpen);
  };
  
  
  const togglePrintTooltip = (index) => {
    const printTooltipOpen = [...printtooltipOpen];
    printTooltipOpen[index] = !printTooltipOpen[index];
    setPrintToolTipOpen(printTooltipOpen);
  };
 
  const handleOpenOrderSumModal = () => {
    setIsOpenOrderSummary(true);
};

// Function to close the order summary modal
const handleCloseOrderSumModal = () => {
    setIsOpenOrderSummary(false);
};

  const handleCloseSummaryConfirmation = () => {
    setIsOpenOrderSummary(false);
  };

  //go to home page
  const handleButtonClickhome = () => {
    // Navigate to a specific route using history.push
    history.push('/home');
  };

//go to table order page
  const handleToRedirectTableOrder = () => {
    // Navigate to a specific route using history.push
    history.push('/tableOrders');
  };


  const openModal = (item,data) => {
    setSelectedItem(item);
    setSelectedorderNo(data);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const fetchAllOrdersHistory = async (order_label) => {
    const startIndexCalc = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndexCalc + itemsPerPage;
    const shopId = localStorage.getItem('shopId');
    try {
        const response = await axios.get(`${var_api}/api/food/normaldate/related-data/${shopId}/${order_label}/${startDate}/${endDate}`);
        const orderHistoryData = response.data;
        if (orderHistoryData.length > 0) {
            setOrderhistory(orderHistoryData.slice(startIndexCalc, endIndex));
            setTotalItems(orderHistoryData.length);
            setStartIndex(startIndexCalc); // Update startIndex state variable
        } else {
            console.log('No data found.');
            setOrderhistory([]);
            setTotalItems(0);
            setStartIndex(0); // Reset startIndex state variable
        }
    } catch (error) {
        console.log('Error fetching data:', error);
    }
};

  const fetchAllOrdersSummary = async (order_label) => {
    const shopId = localStorage.getItem('shopId');
    try {
      const response = await axios.get(`${var_api}/api/food/summary/related-data/${shopId}/${order_label}/${startDate}/${endDate}`);
      const ordersummary = response.data;
        setOrderSummary(ordersummary);
     
    } catch (error) {
      console.log('Error fetching data:', error);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
};

  const formatDate =(dateString) =>{
    const [day, month, year] = dateString.split('-');
    return `${year}-${month}-${day}`;
  }


  //get the value in search and set the setstate
  const handleSearchInput = (e) => {
    setSearchQuery(e.target.value)
    };



    
    const filteredOrders = Array.isArray(orderHistory) && orderHistory.filter((order)=> {
        const searchLower = searchQuery.toLowerCase();
        return(
            (order.order_no && order.order_no.toString().toLowerCase().includes(searchLower)) ||
            (order.cust_name && order.cust_name.toString().toLowerCase().includes(searchLower)) || 
            (order.captain_name && order.captain_name.toString().toLowerCase().includes(searchLower)) ||
            ((order.order_type === 0 && order.order_label === 0 && order.is_group_location_order === 0) && "normal order".includes(searchLower)) ||
            ((order.order_type === 0 && order.order_label === 1 && order.is_group_location_order === 0) && "credit order".includes(searchLower)) ||
            ((order.order_type === 0 && order.order_label === 1 && order.is_group_location_order === 1) && "group location order".includes(searchLower)) ||
            ((order.order_type === 1 && order.order_label === 0 && order.is_group_location_order === 0) && "table normal order".includes(searchLower)) ||
            ((order.order_type === 1 && order.order_label === 1 && order.is_group_location_order === 0) && "table credit order".includes(searchLower))
        )
    })

    //open the bill modal
    const  handleOpenPrintBill = (data,index) => {
        setIsOpenBill(true);
        setSelectedOrderBill(data);
        setBillIndex(index);
    }


    //to open the paymode edit modal
    const handleOpenEditModal = (order) => {
        const sortedPayModes = order.pay_modes.sort((a, b) => a.paymode_id - b.paymode_id);
        setIsPayModeEdit(true);
        setEditPaymodeOrder(order);
        setEditSelectedAmounts(sortedPayModes);
        setUpdateRemark(order.remarks);
    }


    const handleEditCardClick = (id, total) => {
        // Find the index of the pay mode with the given ID
        const index = editSelectedAmounts.findIndex(mode => mode.id === id);
        console.log("inddx", index,editSelectedAmounts);
        
        const updatedEditSelectedAmounts = editSelectedAmounts.map(item => ({
          ...item,
          amount: 0
      }));
      
      if (index !== -1) {
        updatedEditSelectedAmounts[index].amount = total;
      }
      
      // Update the component state with the new array
      setEditSelectedAmounts(updatedEditSelectedAmounts);
       
       
        console.log("after setting", updatedEditSelectedAmounts);
        const modeTO= editSelectedAmounts && editSelectedAmounts.reduce((sum, currentItem) => sum + currentItem.amount, 0)
        setEditModeTotal(modeTO)
      }
      
      
      const handleEditAmountChange = (index, value) => {
       const newSelectedAmounts = [...editSelectedAmounts];
       console.log("after setting textfield", newSelectedAmounts);
        // Set the amount for the corresponding index
        newSelectedAmounts[index].amount = parseFloat(value) || 0;
        console.log("after setting textfield", newSelectedAmounts);
        // Clear the card clicked index
        setEditSelectedAmounts(newSelectedAmounts);
        const modeTO= editSelectedAmounts && editSelectedAmounts.reduce((sum, currentItem) => sum + currentItem.amount, 0)
        setEditModeTotal(modeTO)
      }

     

      // Update the remark value in state when input changes
    const handleRemarkChange = (event) => {
    setUpdateRemark( event.target.value );
  };


  //update method for paymode
const handleUpdatePaymode = () => { 
    const ModeTotal = editSelectedAmounts && editSelectedAmounts.reduce((sum, currentItem) => sum + currentItem.amount, 0)
      if(editPaymodeOrder.total !== ModeTotal){
        Swal.fire({
                icon:"error",
                title:"Oops...",
                text:"Paymode Total is not Equal to Total Amount",
                confirmButtonColor:"#007500"
              })
    
      }
      else{
      setIsPaymodeEditLoading(true);
      const shopID = localStorage.getItem('shopId');
    
       console.log("update",editSelectedAmounts)
       const paymodesArray = editSelectedAmounts.map((mode, index) => ({
        amount:  mode.amount,
        id: mode.id,
        shop_id: parseInt(shopID),
        remarks : updateRemark,
        order_id: mode.order_id
    }));
    
    
       axios
       .put(`${var_api}/api/order-paymode/edit-order-paymodes`, paymodesArray)
       .then((response) => {
      
         toast('Updated Successfully',{autoClose:2000});
         fetchAllOrdersHistory(selectedOrderLabel.value);
         setIsPayModeEdit(false);
         setIsPaymodeEditLoading(false);
         console.log('Data updated successfully:', response.data.message);
       })
       .catch((error) => {
         console.error('Error updating data:', error);
         setIsPaymodeEditLoading(false);
         // Handle error, e.g., show an error message or update the UI accordingly
       });
      }
    };
    
    
  


  return(
    <div class="whole"  style={{ textAlign: "center" ,height:"100%"}}>
    <div className="container-fluid">
        <nav className="navbar" style={{ boxShadow: "0px 0px 1px 0px black", backgroundColor: "green", border: "none", padding: "5px", height: "50px", width: "100%", position: "relative"}}>
            <div style={{ display: "flex"}}>
                <h3 style={{ fontFamily: "cursive", fontWeight: "bolder",marginLeft: "400px", color: "white" }}>{ shopName }</h3>
                <button className="btn" onClick={handleToRedirectTableOrder} style={{  backgroundColor: "white", color: "green", marginLeft:"150px" }}>
                <i class="bi bi-easel"></i> Go to Table Order
                </button>
                {role === "Chef" || role === "Captain" || role === "Waiter" ? null : (
                <button className="btn" onClick={handleButtonClickhome} style={{ backgroundColor: "white", color: "green" , marginLeft:"10px"}}>
                    <i class="bi bi-house"></i> Go to Home
                </button> )}
            </div>
        </nav>
    </div>
      <div>
            <br />
        <h3 style={{ fontFamily: "cursive", fontWeight: "bolder",textAlign: "center", color: "black" }}>Order History</h3>
            <div className="card" style={{ width: '50%', height:'auto',margin:"auto"}}>
    <div className="card-body d-flex flex-column justify-content-center align-items-center">
        <div style={{ display: 'flex', justifyContent: 'center', gap: "35px" }}>
        <Select
                options={labelCodeOptions}
                placeholder="Select Order"
                value={selectedOrderLabel}
                onChange={handleOrderLabelSelectChange}
                isSearchable={true}
                menuPlacement="top"
                className="customSelectFood"
            />
            <label style={{ fontFamily: "serif", fontWeight: "bolder" }}>Date Range: <span className="text-primary" onClick={handleOpenSelectDate}>{startDate} to {endDate}</span>
            <Tooltip
        isOpen={tooltipOpen}
        target="DateIcon" // Specify the target ID of the button
        toggle={toggleTooltip}
        placement="bottom"
      >
        Change Date
      </Tooltip>
            <i className="bi bi-calendar text-primary"  id="DateIcon" style={{ marginLeft: '5px', fontSize: "20px" }} onClick={()=>{handleOpenSelectDate(); toggleTooltip();}}></i> </label>
            <button className="btn btn-danger text-white p-1" onClick={handleOpenOrderSumModal}>Order Summary</button>

        </div>

        {/* <div style={{ display: 'flex', alignItems: 'center', gap: "10px", marginTop: "10px" }}>
            <Select
                options={labelCodeOptions}
                placeholder="Select Order"
                value={selectedOrderLabel}
                onChange={handleOrderLabelSelectChange}
                isSearchable={true}
                menuPlacement="top"
                className="customSelectFood"
            />
            <button className="btn btn-danger text-white p-1" onClick={handleOpenOrderSumModal}>Order Summary</button>
        </div> */}
    </div>
</div>

        </div>
        <input class="form-control" type="Search" placeholder="Search" id="example-search-input" 
      style={{width:"230px",borderRadius:"15px",border:"1px solid black",float:"right",marginRight:"30px"}} onChange={handleSearchInput}/>
<br />
            <br />
            
            <div className="table-container" style={{ height: "auto", overflowX: 'auto', overflowY: 'scroll' }}>
                <table class="table table-hover small-first-col" style={{ border: "none", borderColor: "grey", width: "95%", margin: "auto" ,height:"50%"}}>
                    <thead>
                        <tr style={{ fontWeight: "bolder" }}>
                            <th scope="col">S.No</th>
                            <th scope="col">Order No</th>
                            <th scope="col">Order Type</th>
                            <th scope="col">Cust Name</th>
                            <th scope="col">Captian Name</th>
                            <th scope="col">No.of Items</th>
                            <th scope="col">Pay Mode</th>
                            <th scope="col">Total Amount</th>
                            <th scope="col">Print</th>
                            <th scope='col'>Action</th>
                        </tr>
                    </thead>
                    <tbody class="body-half-screen">
                        {filteredOrders.length > 0 ? (
                            filteredOrders.slice().reverse().map((data, index) => (
                                <tr style={{ padding: "5px" }}>
                                    <td scope="row">{startIndex + index + 1}</td>
                                    <td>{data.order_no}</td>
                                    <td>
                                    {data.order_type === 0 && data.order_label === 0 && data.is_group_location_order ===0 && "Normal Order"}
                                    {data.order_type === 0 && data.order_label === 1 && data.is_group_location_order ===0 && "Credit Order"}
                                    {data.order_type === 0 && data.order_label === 1 && data.is_group_location_order ===1 && "Group Location Order"}
                                    {data.order_type === 1 && data.order_label === 0 && data.is_group_location_order ===0 && "Table Normal Order"}
                                    {data.order_type === 1 && data.order_label === 1 && data.is_group_location_order ===0 && "Table Credit Order"}</td>
                                    <td>{data.cust_name ? data.cust_name : "-"}</td>
                                    <td>{data.captain_name}</td>
                                    <td style={{cursor: 'pointer', color:'red', fontWeight:'bold'}} onClick={() => openModal(data.items, data)}>{data.items.length} {data.items.length === 1 ? 'Item' : 'Items'}</td>
                                    <td>
                                    {data.pay_modes.filter(mode => mode.amount > 0).map((mode, index) => (
                                    <React.Fragment key={index}>
                                      {index > 0 && ", "}
                                      {mode.pay_mode_name}
                                      </React.Fragment>
                                    ))}
                                    </td>
                                    <td>{data.total}</td>
                                    <td>
                                    <Tooltip
        isOpen={printtooltipOpen[index]} // Use tooltip state based on index
        target={`printButton${index}`} // Specify the target ID of the button
        toggle={() => togglePrintTooltip(index)}
        placement='left'
      >
         Print
        </Tooltip>
                                    <button className='btn-md btn-primary'  id={`printButton${index}`}  style={{ borderRadius: "5px", border: "none", padding: "7px", margin:"5px", padding:"0px auto" }} onClick={()=>{handleOpenPrintBill(data,index); togglePrintTooltip(index);}}><i class="bi bi-printer"></i>{" "}</button>
                                    </td>
                                    <td>
                                    <Tooltip
        isOpen={puttooltipOpen[index]} // Use tooltip state based on index
        target={`putButton${index}`} // Specify the target ID of the button
        toggle={() => togglePutTooltip(index)}
        placement='right'
      >
          Edit Paymode
        </Tooltip>
                                    <button className="btn btn-danger" id={`putButton${index}`}  style={{borderRadius: "5px", border: "none", margin:"5px", padding:"0px 6px" }} onClick={()=>{handleOpenEditModal(data); togglePutTooltip(index);}}><i class="bi bi-pencil-square" style={{fontSize:"14px"}}></i></button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" style={{ textAlign: "center" }}>
                                    No Data Available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <br />
                <Pagination
    activePage={currentPage}
    itemsCountPerPage={itemsPerPage}
    totalItemsCount={totalItems} // Update to reflect total items for pagination
    pageRangeDisplayed={5}
    onChange={handlePageChange}
    itemClass="page-item"
    linkClass="page-link"
    innerClass="pagination justify-content-end"
    activeClass="active-pagination" // Custom class for the active pagination item
/>
            </div>
            <Modal
             show={isModalOpen} 
             onHide={closeModal} 
             backdrop="static"
                keyboard={false} 
                size="md" style={{ borderRadius: '20px' }}>
                    <Modal.Header closeButton style={{ backgroundColor: "rgba(6, 105, 16, 0.367)", padding: "12px" }}>
                        <Modal.Title style={{ fontSize: "19px", fontWeight: "bold" }}>Item Details - (Order No:{ selectedOrderNo && selectedOrderNo.order_no})</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
  <div style={{ borderBottom: "2px solid black", paddingBottom: "10px", marginBottom: "10px", display: 'flex', justifyContent: 'space-between' }}>
  <div style={{ width: "30%", textAlign: "left" }}><strong>Food Image</strong></div>
    <div style={{ width: "30%", textAlign: "left" }}><strong>Food Name</strong></div>
    <div style={{ width: "20%", textAlign: "center" }}><strong>Quantity</strong></div>
    <div style={{ width: "20%", textAlign: "center" }}><strong>Unit Price</strong></div>
    <div style={{ width: "20%", textAlign: "center" }}><strong>Item Total</strong></div>
  </div>
  {selectedItem && selectedItem.map((item, index) => {
    const total = item.quantity * item.unit_price;
    return (
      <div className="content" key={index} style={{ borderBottom: "1px solid black", paddingBottom: "5px", marginBottom: "5px", display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ width: "30%", textAlign: "center" }}> <img src={`${var_api}/private/${item.image}`} alt="food_image" height="50px" width="50px" /> </div>
        <div style={{ width: "30%", textAlign: "left" }}>{item.food_name}</div>
        <div style={{ width: "20%", textAlign: "center" }}>{item.quantity}</div>
        <div style={{ width: "20%", textAlign: "center" }}>{item.unit_price}</div>
        <div style={{ width: "20%", textAlign: "center" }}>{total}</div>
      </div>
    );
  })}
  <div style={{ textAlign: "right", marginRight:"35px"}}>
    <strong>Order Total:  </strong>
    {selectedItem && selectedItem.length > 0 ? (
        <span style={{ color: "red",fontWeight:"bold"}}>
            {selectedItem.reduce((acc, item) => acc + (item.quantity * item.unit_price), 0)}
        </span>
    ) : (
        <span style={{ color: "red",fontWeight:"bold"}}>0</span> // Default value if selectedItem is null or empty
    )}
</div>

  <br />
  <div style={{ textAlign: "center"}}>
    <Button variant="danger" onClick={closeModal}>
      Close
    </Button>
  </div>
</Modal.Body>


            </Modal>

            <Modal
                show={isOpenSelectDate}
                onHide={handleCloseDateConfirmation}
                backdrop="static"
                keyboard={false}
                size="md"
                style={{ borderRadius: '20px' }}
            >
                <Modal.Header closeButton style={{ backgroundColor: "rgba(6, 105, 16, 0.367)", padding: "12px" }}>
                    <Modal.Title style={{ fontSize: "19px", fontWeight: "bold" }}>Select Date Range</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                    <div className="col">
                            <label style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>Start Date:</label>
                            <input
                                type='date'
                                name='startDate'
                                style={{ border: "2px ridge green", borderRadius: "15px", height: "35px", padding: "10px" }}
                                placeholder='choose date'
                                onChange={handleStartDateChange}
                                value={formatDate(startDate)}
                            />
                        </div>
                        <div className="col">
                            <label style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>End Date:</label>
                            <input
                                type="date"
                                name='date'
                                placeholder="choose date"
                                onChange={handleEndDateChange}
                                style={{ border: "2px ridge green", borderRadius: "15px", height: "35px", padding: "10px" }}
                                value={formatDate(endDate)}
                                min={formatDate(startDate)}
                            />
                        </div>
                    </div>
                    <br />
                    <div style={{ textAlign: "center" }}>
                        <Button variant="danger" onClick={handleCloseDateConfirmation}>Close</Button>{' '}
                        <Button variant="success" style={{ marginRight: "5px" }} onClick={handleSelectDateRange}>Ok</Button>
                    </div>
                </Modal.Body>
            </Modal>
            
            <Modal
    show={isOpenOrderSummary}
    onHide={handleCloseOrderSumModal}
    backdrop="static"
    keyboard={false}
    size="md"
    style={{ borderRadius: '20px' }}
>
    <Modal.Header closeButton style={{ backgroundColor: "rgba(6, 105, 16, 0.367)", padding: "12px" }}>
        <Modal.Title style={{ fontSize: "19px", fontWeight: "bold" }}>Order Summary</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        <div className="row">
            <div className="col">
                <h6>Order Type </h6>
                <h4>{selectedOrderLabel.label}</h4>
            </div>
            <div className="col">
                <h6>Count </h6>
                <h5>{orderSummary.order_count}</h5>
            </div>
            <div className="col">
                <h6>Total Price </h6>
                <h5>{orderSummary.total_sum}</h5>
            </div>
        </div>
        <br />
        <div style={{ textAlign: "center" }}>
            <Button variant="danger" onClick={handleCloseOrderSumModal}>
                Close
            </Button>
        </div>
    </Modal.Body>
</Modal>


<Modal
    show={isOpenBill}
    onHide={()=>setIsOpenBill(false)}
    backdrop="static"
    keyboard={false}
    size="md"
    style={{ borderRadius: '20px' }}
>
    <Modal.Header closeButton style={{ backgroundColor: "rgba(6, 105, 16, 0.367)", padding: "12px" }}>
        <Modal.Title style={{ fontSize: "19px", fontWeight: "bold" }}>Order Bill</Modal.Title>
    </Modal.Header>
    <Modal.Body >
    
        <br />
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div style={{ marginBottom: '10px' }}>
            <Bill order={selectedOrderBill} ref={(el) => (componentRefs.current[billIndex] = el)} />
        </div>
        <div style={{ textAlign: 'center' }}>
            <ReactToPrint
                trigger={() => (
                    <button className='btn-md btn-primary' style={{ borderRadius: "5px", border: "none", padding: "7px", margin:"5px" }} ><i class="bi bi-printer"></i>{" "}Print</button>
                )}
                content={() => componentRefs.current[billIndex]}
            />
        </div>
    </div>
    </Modal.Body>
</Modal>

<Modal
    show={isPayModeEdit}
    onHide={()=>setIsPayModeEdit(false)}
    backdrop="static"
    keyboard={false}
    size="md"
    style={{ borderRadius: '20px' }}
>
    <Modal.Header closeButton style={{ backgroundColor: "rgba(6, 105, 16, 0.367)", padding: "12px" }}>
        <Modal.Title style={{ fontSize: "19px", fontWeight: "bold" }}>Update Paymode</Modal.Title>
    </Modal.Header>
    <Modal.Body >
    <div className="p-3">
           
           {
    isPaymodeEditLoading ? (
       <div className="text-center">
         <div className="spinner-border" role="status">
           <span className="visually-hidden">Loading...</span>
         </div>
       </div>
     ) : (
       <Button variant="success"  onClick={handleUpdatePaymode} style={{float:"right"}}>
         <i className="bi bi-vector-pen"></i> Update
         </Button>
     )
   }
   <br/>
             <h6 style={{color:"blue", textAlign:"left"}}>Order No: <b>{editPaymodeOrder ? editPaymodeOrder.order_no: " "}</b></h6>
             <h6 style={{color:"green"}}>Total Amount: <b>{editPaymodeOrder ? editPaymodeOrder.total : ""}</b> <span style={{float:"right"}}>Paymode Total: 
             <b style={{color: editPaymodeOrder && editPaymodeOrder.total == editModeTotal ? "green" : "red"}}>{editSelectedAmounts ? editSelectedAmounts.reduce((sum, currentItem) => sum + currentItem.amount, 0) : ""}</b></span></h6>
             
             <div className="row">
               <div className="col">
               <table class="table table-hover">
     <thead>
       <tr>
         <th scope="col" style={{textAlign:"center"}}>Paymode</th>
         <th scope="col" style={{textAlign:"center"}}>Amount</th>
       </tr>
     </thead>
     <tbody>
       {
        editSelectedAmounts && editSelectedAmounts
         .filter(mode => mode.pay_mode_name !== "CREDIT ORDER" && mode.pay_mode_name !== "GROUP LOCATION CREDIT ORDER")
         .map((mode,index)=>(
       <tr key={index}>
         <td>
           <div class={`card ${editSelectedAmounts[index].amount > 0 ? 'bg-success' : ''} ${editSelectedAmounts[index].amount > 0 ? 'text-light' : ''}`} style={{width:"auto", height:"auto", margin:"0px"}} onClick={() =>handleEditCardClick(mode.id, editPaymodeOrder && editPaymodeOrder.total)}>
             <div class="card-body" style={{textAlign:"center"}}>
               {mode.pay_mode_name}
             </div>
           </div>
         </td>
         <td>
          <Input  type="number" id={`paymodeEditAmount${mode.id}`}  value={mode.amount} onChange={(e) => handleEditAmountChange(index, e.target.value)} style={{width:"140px",margin:"auto"}} min="0" />    
         </td>
       </tr>
         ))
       }
       </tbody>
           </table>
               {/* <label class="form-label text-success fw-bold m-0" style={{fontFamily:"serif"}}>Paymode</label>
               <Select
           options={payModeOptions}
           placeholder="Select mode"
           value={editpaymode}
           onChange={this.handlePayModeEditChange}
           isSearchable={true}
           className="customSelectpaymode"
       /> */}
               </div>
               <div className="col">
               <label class="form-label text-success fw-bold m-0" style={{fontFamily:"serif"}}>Remark</label>
               <Input  type="text" id="editremark" placeholder="Remark" required  style={{width:"280px"}} value={updateRemark} onChange={handleRemarkChange} />    
               </div>
             </div>
           </div>
           <div style={{textAlign:"center"}}>
         
             {" "}
            <Button variant="danger"  onClick={()=>setIsPayModeEdit(false)}>
               Close
             </Button>{' '} 
            
            </div>
    </Modal.Body>
</Modal>

    
</div>


    
)
};


export default Orderhistory;